import React from 'react';
import * as BuilderUI from '../../../../../../components/Builder/BuilderUI';

interface IProps {
  variantIndex: number;
}

const VariantLabel = ({ variantIndex }: IProps) => {
  return (
    <BuilderUI.BuilderFieldLabel>{`Variant ${
      variantIndex === 0 ? 'A' : 'B'
    }`}</BuilderUI.BuilderFieldLabel>
  );
};

export default VariantLabel;
